import React, { useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

const SidebarItem = ({icon, text, link, collapsed, style, isActive, noHover}) => {

    const target = useRef(null);
    const [show, setShow] = useState(false);

    if (isActive) return (
        <div
            style={style} 
            className={`
                ${isActive && "selected"} 
                sidebar-item 
                item-link
            `}
        >
            <span style={{fontSize: 25, marginRight: 5, marginTop: -5}}>
                {icon}
            </span>
            {!collapsed && (
                <div style={{display: "flex", flexDirection: "column", lineHeight: 1.2}}>
                    <span>{text}</span>
                </div>
            )}
        </div>
    )

    return (
        <>
            <a
                onMouseEnter={() => {link && collapsed && setShow(true)}}
                onMouseLeave={() => {link && setShow(false)}}
                ref={target}
                href={link} 
                style={style} 
                className={`
                    ${isActive && "selected"} 
                    sidebar-item 
                    ${link && noHover === undefined && 'item-link'}
                `}
            >
                <span style={{fontSize: 25, marginRight: 5, marginTop: -5}}>
                    {icon}
                </span>
                {!collapsed && (
                    <div style={{display: "flex", flexDirection: "column", lineHeight: 1.2}}>
                        <span>{text}</span>
                    </div>
                )}
            </a>
            <Overlay target={target.current} show={show} placement={"right"} 
                rootClose={true} rootCloseEvent="click" onHide={() => setShow(false)}>
                {(props) => (
                    <Tooltip id="overlay" {...props}>
                        {text}
                    </Tooltip>
                )}
            </Overlay>
        </>
    )
}
export default SidebarItem;